export const playerConfig = {
  height: '100%',
  width: '100%',
  playerVars: {
    autoplay: 1,
  },
};
